export default class fontInstaller {
  headElement;

  constructor() {
    this.headElement = document.getElementsByTagName('head')[0];
  }

  set(data = null) {
    if (data) {
      const items = ['/css/fonts/Caveat.css', '/css/fonts/Inconsolata.css'];

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          items.push(`/css/fonts/${data[key].font.replace(' ', '-')}.css`);
        }
      }

      if (items.length > 0) {
        this.assign(items);
      }
    }
  }

  assign(links = []) {
    if (links.length > 0) {
      links = fontInstaller.getUniqueLinks(links);
      links.forEach(link => {
        const fontStylesElement = document.createElement('link');

        fontStylesElement.setAttribute('rel', 'stylesheet');
        fontStylesElement.setAttribute('type', 'text/css');
        fontStylesElement.setAttribute('href', link);

        this.headElement.appendChild(fontStylesElement);
      });
    }
  }

  static getUniqueLinks(links = []) {
    if (links.length > 0) {
      return [...new Set(links)];
    }

    return links;
  }
}
